<script>
  // Eine Zeile ueber der Framework-Tabelle (Configure Framework im Projekt): Stand in Kuerze, aufgebaut wird im
  // Framework Assistant. Liefert der Seite einmal den Stand und die Abteilungen (loaded).
  import { createEventDispatcher, onMount } from "svelte";
  import { fetchWithSession } from "lib/util/fetchWithSession.js";
  import { InfoBlock } from "paxray-components-svelte";

  export let idproject;
  export let frameworkRows = [];
  export let frameworkDataLoaded = false;
  export let assistantEnabled = false;

  const dispatch = createEventDispatcher();

  const count = (number, one, many) => `${number} ${number === 1 ? one : many}`;

  $: framework = summarizeFramework(frameworkRows);
  // Blau statt gruen, solange noch nichts ausgewaehlt ist.
  $: isEmpty = !(framework.l1 || framework.l2 || framework.l3 || framework.l4);

  function summarizeFramework(rows) {
    const levels = ["process", "subprocess", "task", "subtask"];
    const summary = Object.fromEntries(
      levels.map((level, index) => [
        `l${index + 1}`,
        new Set(
          rows.filter((row) => row[level]).map((row) => String(row[level].id)),
        ).size,
      ]),
    );
    return summary;
  }

  onMount(async () => {
    try {
      const response = await fetchWithSession(
        `/api/damprojects/team-surveys?idproject=${idproject}`,
      );
      const result = await response.json();
      if (!response.ok) return;
      dispatch("loaded", {
        framework: result.framework,
        departments: result.departments || [],
      });
    } catch {
      // Die Framework-Zahlen bleiben auch ohne Umfragestatus sichtbar.
    }
  });
</script>

{#if frameworkDataLoaded}
  <InfoBlock
    type={isEmpty ? "info" : "hint"}
    heading={`Project framework · ${count(framework.l1, "process", "processes")} · ${count(framework.l2, "subprocess", "subprocesses")} · ${count(framework.l3, "task", "tasks")} · ${count(framework.l4, "subtask", "subtasks")}`}
    showClose={false}
    showActions={assistantEnabled}
    useMessageSlot
  >
    <div slot="message" class="framework-summary">
      <p>
        Select the subtasks for this project's data collection below, or build
        the framework with guided help.
      </p>
    </div>
    <svelte:fragment slot="actions">
      <slot name="actions" />
    </svelte:fragment>
  </InfoBlock>
{/if}

<style>
  .framework-summary {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }
  p {
    margin: 0;
    line-height: 1.5;
  }
</style>
